import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

const Skeleton = styled.div`
  box-sizing: border-box;
  background-color: lightgray;
  position: relative;
  overflow: hidden;
  ${({ width, height, shape, margin, padding }) => `
    width: ${width ?? "100%"};
    height: ${height ?? "100%"};
    border-radius: ${shape === "circle" ? "50%" : "5px"};
    margin: ${margin ?? "0"};
    padding: ${padding ?? "0"}
  `}

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 200%;
    height: 100%;
    background: linear-gradient(to right, transparent 0%, #f0f0f0 50%, transparent 100%);
    animation: ${shimmer} 1.5s ease-in-out infinite alternate;
  }
`;

const SkeletonWrapper = styled.div`
  margin-bottom: 16px;
`;

/** @param {{ width?: string, height?: string, shape?: string, lines?: number, lineHeight?: string, margin?: string, padding?: string, widthArr?: string[] }} props */
const LoadingSkeleton = ({ width, height, shape, lines, lineHeight, margin, padding, widthArr = [] }) => {
  if (lines && lineHeight) {
    const skeletons = [];
    for (let i = 0; i < lines; i++) {
      skeletons.push(
        <SkeletonWrapper key={i}>
          <Skeleton width={widthArr?.[i] ?? width} height={lineHeight} shape={shape} margin={margin} />
        </SkeletonWrapper>
      );
    }
    return skeletons;
  } else {
    return <Skeleton width={width} height={height} shape={shape} margin={margin} padding={padding} />;
  }
};

export default LoadingSkeleton;
